export function filterSearchParams(obj: Record<string, unknown>): Record<string, string> {
  const filteredEntries = Object.entries(obj).filter(([, value]) => {
    return (
      value !== 'undefined' &&
      value !== null &&
      value !== '' &&
      value !== 'NaN' &&
      value !== 'null'
    );
  });

  return Object.fromEntries(filteredEntries.map(([key, value]) => [key, String(value)]));
}
